module.exports = __webpack_public_path__ + "img/N339-1-EN.27cc7f03.png";